module.exports = {"441225100":"江口镇","441225101":"江川镇","441225102":"白垢镇","441225103":"大洲镇","441225104":"渔涝镇","441225105":"河儿口镇","441225106":"连都镇","441225107":"杏花镇","441225108":"罗董镇","441225109":"长岗镇","441225110":"平凤镇","441225111":"南丰镇","441225112":"大玉口镇","441225113":"都平镇","441225114":"金装镇","441225115":"长安镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441225.json
// module id = 1842
// module chunks = 0